import { Typography } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import CheckIcon from '@mui/icons-material/Check';

const CommandItem = ({ command, copiedId, handleCopy }) => {
  return (
    <div
      style={{
        flex: 1,
        paddingRight: '1rem',
        whiteSpace: 'pre-wrap',
        paddingLeft: '20px',
        fontSize: '16px',
        position: 'relative',
      }}
    >
      <Typography>
        <label style={{marginInlineStart: '25px', fontSize: '18px', color: '#cfcfcf' }}>{command.command}</label>
      </Typography>

      <button
        style={{
          position: 'absolute',
          bottom: '0px',
          left: '5px',
          padding: '0',
          backgroundColor: 'transparent',
          border: 'none',
          cursor: 'pointer',
        }}
        onClick={() => handleCopy(command.id, command.command)}
      >
        <FileCopyIcon style={{ color: '#e4c253', fontSize: '20px' }} />
      </button>

      {copiedId === command.id && (
        <CheckIcon
          style={{
            position: 'absolute',
            bottom: '10px',
            left: '30px',
            color: '#00b327',
            fontSize: '20px',
          }}
        />
      )}
    </div>
  );
};

export default CommandItem;
